import { Modal } from 'bootstrap';

// List view - approve an entry straight from the actions dropdown
function initListApproval() {
	const modalElement = document.getElementById('approveToWorkListModal');
	const form = document.getElementById('approveToWorkListForm');

	if (!modalElement || !form) {
		return;
	}

	const modal = new Modal(modalElement);
	const staffName = document.getElementById('approveStaffName');

	// The extra staff details are mandatory when approving from the list
	modalElement.querySelector('#id_gender').required = true;
	modalElement.querySelectorAll('input[name="type_of_work"]').forEach((radio) => {
		radio.required = true;
	});

	document.querySelectorAll('[data-action="approve-availability"]').forEach((link) => {
		link.addEventListener('click', function (event) {
			event.preventDefault();

			form.action = this.dataset.url;
			staffName.textContent = this.dataset.name || 'this person';

			modal.show();
		});
	});
}

// Create / edit view - the 'Approved to Work' checkbox segues into the modal
function initFormApproval() {
	const form = document.getElementById('staffAvailabilityForm');
	const approvedCheckbox = document.getElementById('id_approved_to_work');
	const modalElement = document.getElementById('approveToWorkModal');

	if (!form || !approvedCheckbox || !modalElement) {
		return;
	}

	const modal = new Modal(modalElement);
	const staffName = document.getElementById('approveStaffName');
	const cancelButton = document.getElementById('cancelApproveToWork');

	// Staff has already been created for this entry - no modal required
	const staffAlreadyCreated = approvedCheckbox.checked && !modalElement.querySelector('.is-invalid');

	function setStaffName() {
		const firstName = document.getElementById('id_first_name').value;
		const lastName = document.getElementById('id_last_name').value;

		staffName.textContent = `${firstName} ${lastName}`.trim() || 'this person';
	}

	function modalFieldsComplete() {
		const gender = document.getElementById('id_gender').value;
		const typeOfWork = modalElement.querySelector('input[name="type_of_work"]:checked');

		return gender && typeOfWork;
	}

	approvedCheckbox.addEventListener('change', function () {
		if (this.checked && !staffAlreadyCreated) {
			setStaffName();
			modal.show();
		}
	});

	// Unchecking on cancel keeps the form state consistent with the modal
	cancelButton.addEventListener('click', function () {
		if (!staffAlreadyCreated) {
			approvedCheckbox.checked = false;
		}
	});

	// Catch saves where 'Approved to Work' is ticked but the extra
	// staff details were never filled in
	form.addEventListener('submit', function (event) {
		if (approvedCheckbox.checked && !staffAlreadyCreated && !modalFieldsComplete()) {
			event.preventDefault();
			setStaffName();
			modal.show();
		}
	});

	// Re-open the modal when the server returned validation errors on its fields
	if (modalElement.querySelector('.is-invalid')) {
		modal.show();
	}
}

document.addEventListener('DOMContentLoaded', function () {
	initListApproval();
	initFormApproval();
});
